// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"c23312b9","915":"021f7827","936":"7f87576c"}[chunkId] + ".chunk.js";
};